import React from "react";
import Hero from "../sections/Hero";
import PainPoints from "../sections/PainPoints";
import WhyO3S from "../sections/WhyO3S";
import Services from "../sections/Services";
import WebsiteTypes from "../sections/WebsiteTypes";
import About from "../sections/About";
import Projects from "../sections/Projects";
import Process from "../sections/Process";
import Contact from "../sections/Contact";

const HomePage = () => {
  return (
    <main className="relative min-h-screen bg-white overflow-hidden">
      <Hero />
      <PainPoints />
      <WhyO3S />
      <Services />
      <Projects />
      <WebsiteTypes />
      <Process />
      <About />

      <Contact />
    </main>
  );
};

export default HomePage;
